import React from "react";
import { Table } from "antd";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const SavedResultHierarchyModal = ({
  isOpenHierarchyResult,
  toggleHierarchyResult,
  columnsHierarchyResult,
  hierarchyListDataResult,
  onClosed = () => {},
}) => {
  return (
    <>
      <Modal
        className={`modal-event-hierarchy-list modal-lg`}
        isOpen={isOpenHierarchyResult}
        toggle={toggleHierarchyResult}
        onClosed={onClosed}
      >
        <ModalHeader>
          <div></div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Table
            pagination={false}
            rowKey="id"
            columns={columnsHierarchyResult}
            dataSource={hierarchyListDataResult}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default SavedResultHierarchyModal;
